import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("fr_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function fileUrl(path) {
  if (!path) return "";
  const i = path.indexOf("/api/files/");
  if (i >= 0) return `${BACKEND_URL}${path.slice(i)}`;
  if (path.startsWith("http") || path.startsWith("data:")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  if (path.startsWith("/")) return path;
  return `${API}/files/${path}`;
}

export const STATUS_OPTIONS = [
  { value: "pendiente_pago", label: "Pendiente de pago" },
  { value: "pago_por_verificar", label: "Pago por verificar" },
  { value: "pagado", label: "Pagado" },
  { value: "en_preparacion", label: "En preparación" },
  { value: "listo_entregar", label: "Listo para entregar" },
  { value: "entregado", label: "Entregado" },
  { value: "cancelado", label: "Cancelado" },
];

export function statusLabel(v) {
  return STATUS_OPTIONS.find((o) => o.value === v)?.label || v;
}

export function formatSoles(n) {
  const num = Number(n || 0);
  return `S/ ${num.toFixed(2)}`;
}

export function priceForQty(product, qty, variant) {
  const v = variant && (product.variants || []).find((x) => x.label === variant && x.price);
  if (v) return Number(v.price);
  let price = Number(product.retail_price || 0);
  if (product.promo_price && Number(product.promo_price) < price) price = Number(product.promo_price);
  for (const t of product.wholesale_tiers || []) {
    if (qty >= t.min_qty && Number(t.price) < price) price = Number(t.price);
  }
  return price;
}

export const cartItemPrice = (i) => priceForQty(i, i.qty, i.variant);
